import { render, staticRenderFns } from "./ViewSaleProduct.vue?vue&type=template&id=7279516b"
import script from "./ViewSaleProduct.vue?vue&type=script&lang=js"
export * from "./ViewSaleProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports